import { Product } from "@/types/product";
import SearchResultItem from "./SearchResultItem";

interface SearchSuggestionsProps {
  suggestions: Product[];
  onSelect: (product: Product) => void;
  show: boolean;
  searchQuery?: string;
}

const SearchSuggestions = ({ suggestions, onSelect, show, searchQuery }: SearchSuggestionsProps) => {
  if (!show || suggestions.length === 0) return null;

  // Limit suggestions to maximum 3 items
  const limitedSuggestions = suggestions.slice(0, 3);

  return (
    <div className="absolute z-10 w-full mt-2 bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 max-h-96 overflow-y-auto animate-fade-in">
      {limitedSuggestions.map((product) => (
        <SearchResultItem
          key={product.objectID}
          product={product}
          onSelect={onSelect}
          searchQuery={searchQuery}
        />
      ))}
    </div>
  );
};

export default SearchSuggestions;